import { ReactNode } from 'react';
import { cx } from '~/common/utils';
import { useNavigation } from './context';

type Props = {
  children: ReactNode;
  className?: string;
};

export const NavigationSection = ({ children, className }: Props) => {
  const { isFromHeader } = useNavigation();

  return (
    <div
      className={cx('flex flex-col def:bg-text-100 rounded', className, {
        'lg:border def:lg:border-solid def:lg:border-other-300 lg:rounded': !isFromHeader,
      })}
    >
      {children}
    </div>
  );
};
